/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var longClick = {
        timer: 0,
        pressed: false,
        fired: false
    },
    LONG_CLICK_TIMEOUT = 600;


module.exports = function ( app, config ) {
    var keyToChange = config.code,
        emitKeyCode = config.emitCode;


    function emitKeydown ( event, redefine ) {
        var page = app.activePage,
            eventLocal = {
                code: event.keyCode,
                stop: false
            },
            eventType,
            activeComponent;

        redefine = redefine || {};

        eventType = redefine.type || event.type;

        // apply key modifiers
        if ( event.ctrlKey )  { eventLocal.code += 'c'; }
        if ( event.altKey )   { eventLocal.code += 'a'; }
        if ( event.shiftKey ) { eventLocal.code += 's'; }
        if ( redefine.code )  { eventLocal.code = redefine.code; }

        console.log('app event: ' + eventType + ' - ' + eventLocal.code, event);

        // page.activeComponent can be set to null in event handles
        activeComponent = page.activeComponent;

        // current component handler
        if ( activeComponent && activeComponent !== page ) {
            // component is available and not page itself
            if ( activeComponent.events[eventType] ) {
                // there are some listeners
                activeComponent.emit(eventType, eventLocal, event);
            }

            // todo: bubble event recursively
            // bubbling
            if (
                !eventLocal.stop
                && activeComponent.propagate
                && activeComponent.parent
                && activeComponent.parent.events[event.type]
            ) {
                activeComponent.parent.emit(eventType, eventLocal, event);
            }
        }

        // page handler
        if ( !eventLocal.stop ) {
            // not prevented
            if ( page.events[eventType] ) {
                // there are some listeners
                page.emit(eventType, eventLocal, event);
            }

            // global app handler
            if ( !event.stop ) {
                // not prevented
                if ( app.events[eventType] ) {
                    // there are some listeners
                    app.emit(eventType, eventLocal, event);
                }
            }
        }
    }

    function keydownHandler ( event ) {
        var page = app.activePage;

        if ( DEVELOP ) {
            if ( !page ) {
                throw new Error(__filename + ': app should have at least one page');
            }
        }

        if ( event.keyCode === keyToChange && !longClick.pressed ) {
            if ( longClick.fired ) {
                longClick.fired = false;
            }
            longClick.pressed = true;
            clearTimeout(longClick.timer);
            longClick.timer = setTimeout(function () {
                emitKeydown(event, {code: emitKeyCode});
                longClick.fired = true;

            }, LONG_CLICK_TIMEOUT);
        } else if ( event.keyCode !== keyToChange ) {
            emitKeydown(event);
        }
    }

    function keyupHandler ( event ) {
        if ( event.keyCode === keyToChange ) {
            if  ( !longClick.fired && longClick.pressed ) {
                clearTimeout(longClick.timer);
                emitKeydown(event, {type: 'keydown'});
            }
            longClick.pressed = false;
        }
    }

    window.addEventListener('keydown', keydownHandler);
    window.addEventListener('keyup', keyupHandler);
};
